import React from "react";
import { get } from "lodash";

const RootCard = ({ root }) => {
  const uuid = get(root, "uuid");

  const handleClick = () => {
    window.location.href = `/node?uuid=${uuid}`;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className="thinCard"
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <span>{root?.name || ""}</span>
    </div>
  );
};
export default RootCard;
